// @flow
import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import Spinner from '../Spinner';

type Spacing = 'large' | 'medium' | 'small' | 'none';

type Props = {
  children: React$Node,
  title?: React$Node,
  spacing?: Spacing,
  use?: 'light' | 'transparent' | 'dark',
  isLoading?: boolean,
  className?: string,
  customBackGround?: string,
  ref?: any,
  height?: number,
  scale?: string,
};

const Card = ({
  title, children, className, spacing = 'large', use = 'transparent', isLoading, customBackGround, ref, height = 0, scale = '',
}: Props) => (
  <section
    ref={ref}
    style={{ background: customBackGround, height: height !== 0 && `${height}px`, transform: scale.length > 0 && scale }}
    className={classnames(styles.card, styles[spacing], styles[use], className)}
  >
    {title && <div className={styles.title}>{title}</div>}
    {isLoading ? <Spinner className={styles[use]} /> : children}
  </section>
);

export default Card;
